import React from 'react';
import { Table, TableBody } from 'semantic-ui-react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

import { AppState } from 'services/types';
// @ts-ignore
import ResponsiveTable from 'components/ResponsiveTable';
import {
    WorksheetPageIndex,
    SprayWorksheetEventProduct
} from 'services/worksheet/types';
import PrintSprayWorksheetProductsTableHeader from './components/PrintSprayWorksheetProductsTableHeader';
import PrintSprayWorksheetProductsTableRow from './components/PrintSprayWorksheetProductsTableRow';
import { makeSelectSprayWorksheetProducts } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
}

interface ConnectedProps {
    products: SprayWorksheetEventProduct[];
}

type Props = OwnProps & ConnectedProps;

export class PrintSprayWorksheetProductsTableComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { pageIndex, products } = this.props;

        return (
            <ResponsiveTable>
                <Table basic="very" className="basic-table" unstackable>
                    <PrintSprayWorksheetProductsTableHeader />
                    <TableBody>
                        {products &&
                            products.map(({ id }) => (
                                <PrintSprayWorksheetProductsTableRow
                                    productId={id}
                                    pageIndex={pageIndex}
                                    key={id}
                                />
                            ))}
                    </TableBody>
                </Table>
            </ResponsiveTable>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    products: makeSelectSprayWorksheetProducts()
});

export default connect(mapStateToProps)(
    PrintSprayWorksheetProductsTableComponent
);
